<div class="image-container"
    #imageWrapper>
  <img
    [attr.src]="imageSrc"
    [alt]="item.mediaAlt"
    class="img"
    [ngStyle]="getImageStyle()"
    [attr.loading]="eager ? 'eager' : 'lazy'"
    [class.loaded]="loaded"
    (load)="onLoadImage()"
  />
  <div  *ngIf="imageUrl.includes('.mp4')" class="play-icon"  [ngStyle]="getIconStyle()">
    <img alt="play-button" src="/assets/icons/play-button.svg"/>
  </div>
</div>
